import React, { useEffect } from "react";
import { Subtitle1, mergeClasses } from "@fluentui/react-components";
import { useStyles } from "../shared/SharedStyles";
import { appInsightsEvents, trackEvent, useAppStore } from "../../common";
import { CafeCard } from "../BuildingView/CafeCard";
import { ICafeListItemViewModel } from "@dining/api-client";

interface FavoriteCafesCardCardProps {
  favoriteCafes: ICafeListItemViewModel[];
}

export const FavoriteCafeCard = ({ favoriteCafes }: FavoriteCafesCardCardProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "FavoriteCafeCard",
    });
  }, [context, appInsights]);
  return (
    favoriteCafes && (
      <div
        data-testid="favoriteCafes"
        className={mergeClasses(styles.listContainer, styles.bottomSpacer, styles.container)}
      >
        <Subtitle1 className={mergeClasses(styles.header, styles.headerText)}>
          Default Location
        </Subtitle1>

        <div className={styles.list}>
          {favoriteCafes.map((cafe, i) => (
            <CafeCard key={i} cafe={cafe} />
          ))}
        </div>
      </div>
    )
  );
};
